const TechnicalRU7 = () => {
    return (
        <div>
            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "16px" } }><strong>чтобы понять&nbsp;кaкие&nbsp;шин&nbsp;потребовалось&nbsp;Для&nbsp;мотоциклa,&nbsp;надо&nbsp;понять&nbsp;кaкои&nbsp;стиль вождения.</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td style={ { textAlign: "center" } }>
                        <p><span style={ { fontSize: "16px" } }><img alt="" src="http://www.rubbers.lv/upload/pictures/237/content_content_street_tire.jpg" style={ { height: "200px", width: "200px" } } /></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }>&nbsp; <span style={ { color: "#000000" } }><strong>&nbsp;Спортивные уличные шины</strong></span> для&nbsp;агрессивныx&nbsp;водителеи,которые большую часть своего времени, затраченного &laquo;за исключением закона&raquo; на дорогах общего пользования.Благодаря многокомпонентного состава шины боковые края являются мягкими, что делает безопасное маневрирование, в то время как центр шины изготовлен из твердой композиции, чтобы служить дольше.Улицы и спортивные уличные шины имеют хорошее сцепление с дорогой даже в холодной погоде, но когда он нагревается тоже могут потерять сцепление с дорогой.</span></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td style={ { textAlign: "center" } }>
                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }><img alt="" src="http://www.rubbers.lv/upload/pictures/238/content_content_sport_touring.jpg" style={ { height: "200px", width: "200px" } } /><img alt="" src="http://www.rubbers.lv/upload/pictures/239/content_content_touring.jpg" style={ { height: "200px", width: "200px" } } /></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }>&nbsp; &nbsp;</span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }><span style={ { color: "#000000" } }><strong>&nbsp;</strong></span></span></p>

                        <p style={ { textAlign: "left" } }>&nbsp;</p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }><span style={ { color: "#000000" } }><strong>&nbsp;</strong></span></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }><span style={ { color: "#000000" } }><strong>&nbsp; &nbsp;Спорт Touring шины</strong></span>, как правило, сделаны из более сильного каучука с большей силой. Они могут иметь более длинную жизнеспособность, но они, как правило, дают меньшее сцепление, чем спортивные шины до оптимальной температуры. Компромисс в том, что туристы шины, как правило, предлагают лучшее сцепление при более низких температурах, что означает, что они больше подходят для езды в холодную погоду или в зимний период, в то время как спортивные шины никогда не достигают оптимальной рабочей температуры.</span></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td style={ { textAlign: "center" } }>
                        <p><span style={ { fontSize: "16px" } }><img alt="" src="http://www.rubbers.lv/upload/pictures/240/content_content_X001-Y001.jpg" style={ { height: "200px", width: "200px" } } /></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }>&nbsp; &nbsp;<span style={ { color: "#000000" } }><strong>Super Sport шина</strong></span> обеспечивает отличное сцепление с дорогой, но может путешествовать 1,600km или меньше. Существует также тип шины, разработанный специально для конкурса. Эти шины обеспечивают высокий уровень сцепления при прохождении поворотов. Из-за высокой температуры, при которой эти шины, как правило, работает, используйте на улице небезопасно, так как шины, как правило, не может достичь оптимальной температуры, прежде чем водитель прибывает в пункт назначения, таким образом, не сцепление с дорогой. Спортивные ситуации - гоночные шины, как правило, растет температуру с помощью грелки шин.</span><br />
                        &nbsp;</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td style={ { textAlign: "center" } }>
                        <p><span style={ { fontSize: "16px" } }><img alt="" src="http://www.rubbers.lv/upload/pictures/241/content_content_offroad.jpg" style={ { height: "200px", width: "80px" } } /><img alt="" src="http://www.rubbers.lv/upload/pictures/242/content_content_touring__1_.jpg" style={ { height: "200px", width: "98px" } } /></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }>&nbsp; &nbsp;<span style={ { color: "#000000" } }><strong>Off Road шины</strong></span> имеют узловатые, глубокие протекторы для максимального сцепления и грязи, грязи, песка или гравия на полях: такие шины имеют тенденцию быть менее стабильным на поверхности дороги.</span></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td style={ { textAlign: "center" } }>
                        <p><span style={ { fontSize: "16px" } }><img alt="" src="http://www.rubbers.lv/upload/pictures/243/content_content_slick.jpg" style={ { height: "200px", width: "200px" } } /></span></p>

                        <p style={ { textAlign: "left" } }><span style={ { fontSize: "16px" } }>&nbsp; <span style={ { color: "#000000" } }><strong>&nbsp;Трек / Slika спроектированные трассы</strong></span> и гонки. Они могут быть более треугольные участки, которые, в свою очередь, обеспечивает большую площадь контакта для изгибов. Производители шин не рекомендуются для использования на улицах и, как известно для вождения на улицах его короткое время жизни. Благодаря триангуляции шин, центр будет иметь меньшую площадь контакта, в результате чего шины развивать равнину, вождение на прямых дорог в течение длительного времени, и он не топтать, который теряет почти все сцепление на мокрой дороге. Гонки всегда Slika сделаны из мягкой резиновой смеси и не обеспечивают много тяги как уличные шины, а не нагреваются до более высокой внутренней температуры, чем уличные шины, как правило, работает.</span></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>
        </div>
    );
};

export default TechnicalRU7;


